import { format } from 'date-fns';
import React from 'react';
import { Image, Linking, TouchableOpacity } from 'react-native';

import { Box, Text } from '@components/Restyle';

export interface ProjectMediaType {
  id: string;
  name: string;
  contentType: string;
  createdAt: string;
  size: number;
  isImage: boolean;
  clientId: string;
  isAudio: boolean;
  duration?: null;
  file: AvatarOrFile;
  owner: Owner;
}

export interface AvatarOrFile {
  id: string;
  cdnBaseUrl: string;
  path: string;
  isPreviewable: boolean;
  thumbnail?: null;
}
export interface Owner {
  id: string;
  name: string;
  firstName: string;
  lastName: string;
  createdAt: string;
  avatar: AvatarOrFile;
}

const ImagesComponent = ({ item }: { item: ProjectMediaType }) => {
  if (item?.file?.cdnBaseUrl && item?.isImage) {
    return (
      <TouchableOpacity
        onPress={() => {
          Linking.openURL(`${item?.file?.cdnBaseUrl}/${item?.file?.path}`);
        }}>
        <Box key={item?.file?.path} margin='l'>
          <Box>
            <Image
              style={{
                height: 200,
                width: 330,
                borderTopLeftRadius: 12,
                borderTopRightRadius: 12,
              }}
              source={{
                uri: `${item?.file?.cdnBaseUrl}/${item?.file?.path}`,
              }}
            />
          </Box>

          <Box
            width={330}
            height='auto'
            paddingVertical='xxs'
            paddingHorizontal='s'
            marginBottom='s'
            style={{
              backgroundColor: '#F7F8FA',
              borderBottomLeftRadius: 12,
              borderBottomRightRadius: 12,
            }}>
            <Box flex={1} flexDirection='row' justifyContent='space-between'>
              <Text
                variant='labelSmall'
                fontSize={14}
                fontWeight='500'
                marginRight='xxs'
                style={{ marginTop: 2 }}>
                {item?.owner?.name ?? ''}
              </Text>
              <Text
                fontSize={14}
                fontWeight='500'
                style={{
                  color: 'grey04',
                  opacity: 0.5,
                }}>
                {`${format(
                  item?.createdAt ?? '2025-03-12T05:30:00+05:30',
                  'MMM dd, yyyy'
                )} at ${format(
                  item?.createdAt ?? '2025-03-12T05:30:00+05:30',
                  'hh:mm aa'
                )}`}
              </Text>
            </Box>
          </Box>
        </Box>
      </TouchableOpacity>
    );
  }
  return null;
};

export const ProjectImages = ({
  data,
}: {
  data: Array<ProjectMediaType> | undefined;
}) => {
  return (
    <Box>
      <Box>
        <Text
          variant='heading1'
          color='textPrimary'
          fontWeight='600'
          fontSize={28}
          marginHorizontal='m'
          marginVertical='l'
          textAlign='left'>
          Project Photos
        </Text>
      </Box>
      <Box>
        <Text
          variant='heading1'
          color='textPrimary'
          fontWeight='700'
          fontSize={18}
          marginHorizontal='m'
          marginVertical='l'
          textAlign='left'>
          Photos
        </Text>
      </Box>
      <Box
        flexDirection='row'
        flexWrap='wrap'
        marginHorizontal='l'
        justifyContent='space-around'>
        {data?.map((item) => (
          <ImagesComponent key={item?.file?.cdnBaseUrl} item={item} />
        ))}
      </Box>
    </Box>
  );
};
